"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Document = require("./Document");
Object.keys(_Document).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Document[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Document[key];
    }
  });
});